import React, { useCallback } from 'react';
import { defaultPresaveServices } from 'fym-shared/src/smartlinks/presave';
import { TypedMemo } from '../../../common/types';
import { Spacer } from '../../../common/views/spacer/Spacer';
import { FormInputContainer } from '../../../forms/components/FormInputContainer/FormInputContainer';
import { PresaveServiceToggle } from './PresaveServiceToggle';
import { PresaveServicesFieldProps } from './props';

/**
 * The services the pre-save block offers. The choice is limited to the ones
 * musicapi can actually save a track into — a button for anything else would
 * take a fan's consent and give them nothing on release day.
 */
const PresaveServicesFieldComponent: React.FC<PresaveServicesFieldProps> = ({
  label,
  help,
  selected,
  onChange,
  disabled,
}) => {
  const onToggle = useCallback(
    (integrationType: string) => {
      onChange(
        selected.includes(integrationType)
          ? selected.filter((service) => service !== integrationType)
          : [...selected, integrationType]
      );
    },
    [onChange, selected]
  );

  return (
    <FormInputContainer name="services" label={label} help={help} error={undefined} isDirty={false} isTouched={false}>
      <Spacer flex flexDirection="row" flexWrap="wrap">
        {defaultPresaveServices.map((integrationType) => (
          <PresaveServiceToggle
            key={integrationType}
            integrationType={integrationType}
            checked={selected.includes(integrationType)}
            disabled={disabled}
            onToggle={onToggle}
          />
        ))}
      </Spacer>
    </FormInputContainer>
  );
};

export const PresaveServicesField = TypedMemo(PresaveServicesFieldComponent);
